import React, { useState } from 'react';
import 'react-image-lightbox/style.css';
import Lightbox from 'react-image-lightbox';
import "./newsevent.css";


import AGMimg1 from '../../assets/AGM1.jpg';
import AGMimg2 from '../../assets/AGM2.jpg';
import AGMimg3 from '../../assets/AGM3.jpg';
import AGMimg4 from '../../assets/AGM4.jpg';
import AGMimg5 from '../../assets/AGM5.jpg';
import AGMimg6 from '../../assets/AGM6.jpg';
import AGMimg7 from '../../assets/AGM7.jpg';
import AGMimg8 from '../../assets/AGM8.jpg';
import AGMimg9 from '../../assets/AGM9.jpg';
import AGMimg10 from '../../assets/AGM10.jpg';
import AGMimg11 from '../../assets/AGM11.jpg';
import AGMimg12 from '../../assets/AGM12.jpg';
import AGMimg13 from '../../assets/AGM13.jpg';
import AGMimg14 from '../../assets/AGM14.jpg';
import AGMimg15 from '../../assets/AGM15.jpg';
import AGMimg16 from '../../assets/AGM16.jpg';
import AGMimg17 from '../../assets/AGM17.jpg';
import AGMimg18 from '../../assets/AGM18.jpg';




const sections = [
  {
   
    images: [AGMimg1, AGMimg2, AGMimg3, AGMimg4, AGMimg5, AGMimg6, AGMimg7, AGMimg8 , AGMimg9, AGMimg10, AGMimg11, AGMimg12 , AGMimg13, AGMimg14, AGMimg15, AGMimg16 , AGMimg17 , AGMimg18],
  },
];

const AnnualMeeting = () => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  const openViewer = (images, index) => {
    setCurrentImages(images);
    setPhotoIndex(index);
    setIsViewerOpen(true);
  };

  const closeViewer = () => {
    setIsViewerOpen(false);
  };

  return (
    <div className="gallery">
      <h1 align="center">Annual General Meeting - 2024</h1>
      <p className="intro-annualmeeting">The AGM 2024 of the Eye Care Institute was a significant event bringing together staff, and partners to review the year's achievements and plan future initiatives.</p>
      <br />
      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex} className="gallery-section">
          <div className="gallery-header">
            <h2>{section.title}</h2>
          </div>
          <div className="gallery-grid">
            {section.images.map((src, index) => (
              <div key={index} className="gallery-item">
                <div className="overlay-container">
                <img
                    src={src}
                    alt={`Gallery item ${index + 1} in ${section.title}`} // Avoid the word "image"
                    className="gallery-image"
                    onClick={() => openViewer(section.images, index)}
                  />

                  <div className="overlay">
                    <button
                      className="max-view-button"
                      onClick={() => openViewer(section.images, index)}
                    >
                      <span>&#x2922;</span> {/* Fullscreen icon */}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {isViewerOpen && (
        <Lightbox
          mainSrc={currentImages[photoIndex]}
          nextSrc={currentImages[(photoIndex + 1) % currentImages.length]}
          prevSrc={
            currentImages[
              (photoIndex + currentImages.length - 1) % currentImages.length
            ]
          }
          onCloseRequest={closeViewer}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + currentImages.length - 1) % currentImages.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % currentImages.length)
          }
        />
      )}
    </div>
  );
};
export default AnnualMeeting